import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-callback-dialog',
  templateUrl: './callback-dialog.component.html',
  styleUrls: ['./callback-dialog.component.scss'],
})
export class CallbackDialogComponent implements OnInit {
  name: string = '';
  phone: string = '';
  email: string = '';
  message: string = '';

  constructor(
    public dialogRef: MatDialogRef<CallbackDialogComponent>,
  ) {}

  ngOnInit(): void {}

  onSubmit(): void {
    const subject = encodeURIComponent(`Callback Request from ${this.name}`);
    const body = encodeURIComponent(
      `Name: ${this.name}\n` +
      `Phone: ${this.phone}\n` +
      `Email: ${this.email}\n\n` +
      `Additional Details:\n${this.message}`
    );
    
    const mailtoUrl = `mailto:support@lenexamedical.com?subject=${subject}&body=${body}`;
    window.location.href = mailtoUrl;
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close();
  }
}
